import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateMobilityRunEstimatesMutationVariables = Types.Exact<{
  runId: Types.Scalars['bigint']['input'];
  estimatedDurationMinutes?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  estimatedDistanceMiles?: Types.InputMaybe<Types.Scalars['numeric']['input']>;
  expectedReturnTime?: Types.InputMaybe<Types.Scalars['timestamptz']['input']>;
  stopUpdates: Array<Types.Mobility_Stops_Updates> | Types.Mobility_Stops_Updates;
}>;


export type UpdateMobilityRunEstimatesMutation = { __typename?: 'mutation_root', update_mobility_runs_by_pk?: { __typename?: 'mobility_runs', id: number, estimated_duration_minutes?: number | null, estimated_distance_miles?: number | null, expected_return_time?: string | null } | null, update_mobility_stops_many?: Array<{ __typename?: 'mobility_stops_mutation_response', affected_rows: number } | null> | null };


export const UpdateMobilityRunEstimatesDocument = gql`
    mutation updateMobilityRunEstimates($runId: bigint!, $estimatedDurationMinutes: Int, $estimatedDistanceMiles: numeric, $expectedReturnTime: timestamptz, $stopUpdates: [mobility_stops_updates!]!) {
  update_mobility_runs_by_pk(
    pk_columns: {id: $runId}
    _set: {estimated_duration_minutes: $estimatedDurationMinutes, estimated_distance_miles: $estimatedDistanceMiles, expected_return_time: $expectedReturnTime}
  ) {
    id
    estimated_duration_minutes
    estimated_distance_miles
    expected_return_time
  }
  update_mobility_stops_many(updates: $stopUpdates) {
    affected_rows
  }
}
    `;
export type UpdateMobilityRunEstimatesMutationFn = Apollo.MutationFunction<UpdateMobilityRunEstimatesMutation, UpdateMobilityRunEstimatesMutationVariables>;

/**
 * __useUpdateMobilityRunEstimatesMutation__
 *
 * To run a mutation, you first call `useUpdateMobilityRunEstimatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMobilityRunEstimatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMobilityRunEstimatesMutation, { data, loading, error }] = useUpdateMobilityRunEstimatesMutation({
 *   variables: {
 *      runId: // value for 'runId'
 *      estimatedDurationMinutes: // value for 'estimatedDurationMinutes'
 *      estimatedDistanceMiles: // value for 'estimatedDistanceMiles'
 *      expectedReturnTime: // value for 'expectedReturnTime'
 *      stopUpdates: // value for 'stopUpdates'
 *   },
 * });
 */
export function useUpdateMobilityRunEstimatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMobilityRunEstimatesMutation, UpdateMobilityRunEstimatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMobilityRunEstimatesMutation, UpdateMobilityRunEstimatesMutationVariables>(UpdateMobilityRunEstimatesDocument, options);
      }
export type UpdateMobilityRunEstimatesMutationHookResult = ReturnType<typeof useUpdateMobilityRunEstimatesMutation>;
export type UpdateMobilityRunEstimatesMutationResult = Apollo.MutationResult<UpdateMobilityRunEstimatesMutation>;
export type UpdateMobilityRunEstimatesMutationOptions = Apollo.BaseMutationOptions<UpdateMobilityRunEstimatesMutation, UpdateMobilityRunEstimatesMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (update_mobility_runs_by_pk, update_mobility_stops_many): returns the full response object.
 * @source {@link src/features/mobileService/queries/updateMobilityRunEstimates.mutation.gql}
 */
export async function updateMobilityRunEstimates(
  variables: UpdateMobilityRunEstimatesMutationVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<UpdateMobilityRunEstimatesMutation> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).mutate<UpdateMobilityRunEstimatesMutation>(
    UpdateMobilityRunEstimatesDocument,
    variables,
    requestOptions
  )
}